import React from 'react';
import TranslationContext from './TranslationContext';
import makeTranslationHelpers from './helpers/makeTranslationHelpers';
import useDocumentDirection from './useDocumentDirection';
const TranslationProvider = ({ children = null, locale = {}, language = 'English', }) => {
    const parentContext = React.useContext(TranslationContext);
    const context = React.useMemo(() => {
        const locales = [locale, ...parentContext.locales];
        return {
            locales,
            ...makeTranslationHelpers(language, locales),
        };
    }, [language, locale, parentContext]);
    useDocumentDirection(context.direction);
    return (<TranslationContext.Provider value={context}>
      {children}
    </TranslationContext.Provider>);
};
export default TranslationProvider;
